module.exports = __webpack_public_path__ + "img/course-blanc.345ca93c.png";